import withFileHandlers from '../../../hoc/withFileHandlers';

import RoutesImporter from './RoutesImporter';

export default withFileHandlers()(RoutesImporter);
